module.exports = __webpack_public_path__ + "media/39.96819ca6.mp3";